import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=bc8cbce6&scoped=true&lang=pug&"
import script from "./AppLink.vue?vue&type=script&lang=js&"
export * from "./AppLink.vue?vue&type=script&lang=js&"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=bc8cbce6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8cbce6",
  null
  
)

export default component.exports